import update from 'immutability-helper'

const getInitialState = () => {
  const showConnectionsString = window.localStorage.getItem('showConnections')
  const showAllConnectionsString =
    window.localStorage.getItem('showAllConnections')

  // Default to showing all connections (both true)
  const showConnections = showConnectionsString
    ? JSON.parse(showConnectionsString)
    : true

  const showAllConnections = showAllConnectionsString
    ? JSON.parse(showAllConnectionsString)
    : true

  return {
    showConnections,
    showAllConnections,
  }
}

// TYPES
export const TOGGLE_CONNECTIONS = Symbol('TOGGLE_CONNECTIONS')
export const TOGGLE_ALL_CONNECTIONS = Symbol('TOGGLE_ALL_CONNECTIONS')

// REDUCER
export default (state = getInitialState(), action) => {
  switch (action?.type) {
    case TOGGLE_CONNECTIONS: {
      const showConnections = !state.showConnections

      // update localStorage with the new value
      window.localStorage.setItem('showConnections', showConnections)

      // If turning off connections, also turn off showAllConnections
      const updates = showConnections
        ? { showConnections }
        : { showConnections, showAllConnections: false }

      if (!showConnections) {
        window.localStorage.setItem('showAllConnections', false)
      }

      return update(state, { $merge: updates })
    }

    case TOGGLE_ALL_CONNECTIONS: {
      const showAllConnections = !state.showAllConnections

      // update localStorage with the new value
      window.localStorage.setItem('showAllConnections', showAllConnections)

      return update(state, { $merge: { showAllConnections } })
    }

    default:
      return state
  }
}

// ACTIONS
export const toggleConnections = () => ({ type: TOGGLE_CONNECTIONS })
export const toggleAllConnections = () => ({ type: TOGGLE_ALL_CONNECTIONS })

// SELECTORS
export const getShowConnections = state => {
  return state.settings.showConnections
}

/**
 *
 * @param {*} state
 * @returns {boolean}
 */
export const getShowAllConnections = state => {
  return state.settings.showAllConnections
}
